var map = {
	"./en.json": [
		1666,
		60
	],
	"./et.json": [
		1667,
		59
	],
	"./fi.json": [
		1668,
		58
	],
	"./lv.json": [
		1669,
		57
	],
	"./pl.json": [
		1670,
		56
	],
	"./ru.json": [
		1671,
		55
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1663;


//////////////////
// WEBPACK FOOTER
// ./src/i18n lazy ^\.\/.*\.json$
// module id = 1663
// module chunks = 62